import React, { useState, useEffect } from 'react';
import axios from 'axios';

const MasterAsramaPengayaan = () => {
  const [tab, setTab] = useState('asrama'); // 'asrama' atau 'pengayaan'
  
  // State Asrama
  const [asramaList, setAsramaList] = useState([]);
  const [namaAsrama, setNamaAsrama] = useState('');
  const [selectedAsrama, setSelectedAsrama] = useState(null);
  
  // State Pengayaan
  const [pengayaanList, setPengayaanList] = useState([]);
  const [namaKelompok, setNamaKelompok] = useState('');
  const [mapelPengayaan, setMapelPengayaan] = useState('');
  const [selectedPengayaan, setSelectedPengayaan] = useState(null);

  // State Siswa
  const [allSiswa, setAllSiswa] = useState([]);
  const [selectedSiswaIds, setSelectedSiswaIds] = useState([]);

  const API_URL = 'http://localhost:10000/api'; // Sesuaikan IP VPS / URL API kamu

  useEffect(() => {
    fetchSiswa();
    fetchAsrama();
    fetchPengayaan();
  }, []);

  const fetchSiswa = async () => {
    try {
      const res = await axios.get(`${API_URL}/siswa`);
      setAllSiswa(res.data);
    } catch (err) { console.error(err); }
  };

  const fetchAsrama = async () => {
    try {
      const res = await axios.get(`${API_URL}/asrama`);
      setAsramaList(res.data);
    } catch (err) { console.error(err); }
  };

  const fetchPengayaan = async () => {
    try {
      const res = await axios.get(`${API_URL}/pengayaan`);
      setPengayaanList(res.data);
    } catch (err) { console.error(err); }
  };

  // --- LOGIKA ASRAMA ---
  const handleTambahAsrama = async (e) => {
    e.preventDefault();
    if (!namaAsrama) return;
    try {
      await axios.post(`${API_URL}/asrama`, { nama_asrama: namaAsrama });
      setNamaAsrama('');
      fetchAsrama();
    } catch (err) { alert('Gagal menambah asrama'); }
  };

  const handleSelectAsrama = async (item) => {
    setSelectedAsrama(item);
    try {
      const res = await axios.get(`${API_URL}/asrama/${item.id}/anggota`);
      setSelectedSiswaIds(res.data.map(s => s.id));
    } catch (err) { console.error(err); }
  };

  const handleSimpanAnggotaAsrama = async () => {
    if (!selectedAsrama) return;
    try {
      await axios.post(`${API_URL}/asrama/${selectedAsrama.id}/anggota`, {
        siswaIds: selectedSiswaIds
      });
      alert('Anggota asrama berhasil diperbarui!');
    } catch (err) { alert('Gagal menyimpan anggota asrama'); }
  };

  // --- LOGIKA PENGAYAAN ---
  const handleTambahPengayaan = async (e) => {
    e.preventDefault();
    if (!namaKelompok || !mapelPengayaan) return;
    try {
      await axios.post(`${API_URL}/pengayaan`, { 
        nama_kelompok: namaKelompok, 
        mapel: mapelPengayaan 
      });
      setNamaKelompok('');
      setMapelPengayaan('');
      fetchPengayaan();
    } catch (err) { alert('Gagal menambah kelompok pengayaan'); }
  };

  const handleSelectPengayaan = async (item) => {
    setSelectedPengayaan(item);
    try {
      const res = await axios.get(`${API_URL}/pengayaan/${item.id}/anggota`);
      setSelectedSiswaIds(res.data.map(s => s.id));
    } catch (err) { console.error(err); }
  };

  const handleSimpanAnggotaPengayaan = async () => {
    if (!selectedPengayaan) return;
    try {
      await axios.post(`${API_URL}/pengayaan/${selectedPengayaan.id}/anggota`, {
        siswaIds: selectedSiswaIds
      });
      alert('Anggota kelompok pengayaan berhasil diperbarui!');
    } catch (err) { alert('Gagal menyimpan anggota pengayaan'); }
  };

  // Checkbox Handler
  const handleCheckboxChange = (siswaId) => {
    if (selectedSiswaIds.includes(siswaId)) {
      setSelectedSiswaIds(selectedSiswaIds.filter(id => id !== siswaId));
    } else {
      setSelectedSiswaIds([...selectedSiswaIds, siswaId]);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>Manajemen Asrama & Kelompok Pengayaan</h2>
      
      {/* Tab Switcher */}
      <div style={{ marginBottom: '20px' }}>
        <button 
          onClick={() => { setTab('asrama'); setSelectedAsrama(null); setSelectedSiswaIds([]); }}
          style={{ fontWeight: tab === 'asrama' ? 'bold' : 'normal', marginRight: '10px' }}
        >
          Kelola Asrama
        </button>
        <button 
          onClick={() => { setTab('pengayaan'); setSelectedPengayaan(null); setSelectedSiswaIds([]); }}
          style={{ fontWeight: tab === 'pengayaan' ? 'bold' : 'normal' }}
        >
          Kelola Kelompok Pengayaan
        </button>
      </div>

      <hr />

      {/* TAB ASRAMA */}
      {tab === 'asrama' && (
        <div style={{ display: 'flex', gap: '20px' }}>
          {/* Kolom Kiri: Form & Daftar Asrama */}
          <div style={{ flex: 1 }}>
            <h3>Daftar Asrama</h3>
            <form onSubmit={handleTambahAsrama} style={{ marginBottom: '15px' }}>
              <input 
                type="text" 
                placeholder="Nama Asrama (misal: Asrama Putra 1)" 
                value={namaAsrama}
                onChange={(e) => setNamaAsrama(e.target.value)}
                style={{ padding: '5px', width: '70%' }}
              />
              <button type="submit" style={{ padding: '5px 10px', marginLeft: '5px' }}>+ Tambah</button>
            </form>

            <ul>
              {asramaList.map((item) => (
                <li key={item.id} style={{ marginBottom: '8px' }}>
                  <button 
                    onClick={() => handleSelectAsrama(item)}
                    style={{ fontWeight: selectedAsrama?.id === item.id ? 'bold' : 'normal' }}
                  >
                    {item.nama_asrama}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Kolom Kanan: Mapping Siswa */}
          <div style={{ flex: 2 }}>
            {selectedAsrama ? (
              <>
                <h3>Anggota: {selectedAsrama.nama_asrama}</h3>
                <button onClick={handleSimpanAnggotaAsrama} style={{ marginBottom: '10px', padding: '5px 15px' }}>
                  Simpan Perubahan Anggota
                </button>
                <div style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid #ccc', padding: '10px' }}>
                  {allSiswa.map((s) => (
                    <div key={s.id} style={{ marginBottom: '5px' }}>
                      <label>
                        <input 
                          type="checkbox"
                          checked={selectedSiswaIds.includes(s.id)}
                          onChange={() => handleCheckboxChange(s.id)}
                        />
                        {s.nama} ({s.kelas}) - {s.jenis_kelamin}
                      </label>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <p><i>Pilih salah satu asrama di sebelah kiri untuk mengatur anggotanya.</i></p>
            )}
          </div>
        </div>
      )}

      {/* TAB PENGAYAAN */}
      {tab === 'pengayaan' && (
        <div style={{ display: 'flex', gap: '20px' }}>
          {/* Kolom Kiri: Form & Daftar Pengayaan */}
          <div style={{ flex: 1 }}>
            <h3>Daftar Kelompok Pengayaan</h3>
            <form onSubmit={handleTambahPengayaan} style={{ marginBottom: '15px' }}>
              <input 
                type="text" 
                placeholder="Nama Kelompok" 
                value={namaKelompok}
                onChange={(e) => setNamaKelompok(e.target.value)}
                style={{ padding: '5px', width: '100%', marginBottom: '5px' }}
              />
              <input 
                type="text" 
                placeholder="Mata Pelajaran" 
                value={mapelPengayaan}
                onChange={(e) => setMapelPengayaan(e.target.value)}
                style={{ padding: '5px', width: '100%', marginBottom: '5px' }}
              />
              <button type="submit" style={{ padding: '5px 10px' }}>+ Tambah Kelompok</button>
            </form>

            <ul>
              {pengayaanList.map((item) => (
                <li key={item.id} style={{ marginBottom: '8px' }}>
                  <button 
                    onClick={() => handleSelectPengayaan(item)}
                    style={{ fontWeight: selectedPengayaan?.id === item.id ? 'bold' : 'normal' }}
                  >
                    {item.nama_kelompok} ({item.mapel})
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Kolom Kanan: Mapping Siswa Gabungan */}
          <div style={{ flex: 2 }}>
            {selectedPengayaan ? (
              <>
                <h3>Anggota: {selectedPengayaan.nama_kelompok} ({selectedPengayaan.mapel})</h3>
                <button onClick={handleSimpanAnggotaPengayaan} style={{ marginBottom: '10px', padding: '5px 15px' }}>
                  Simpan Perubahan Anggota
                </button>
                <div style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid #ccc', padding: '10px' }}>
                  {allSiswa.map((s) => (
                    <div key={s.id} style={{ marginBottom: '5px' }}>
                      <label>
                        <input 
                          type="checkbox"
                          checked={selectedSiswaIds.includes(s.id)}
                          onChange={() => handleCheckboxChange(s.id)}
                        />
                        {s.nama} ({s.kelas})
                      </label>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <p><i>Pilih salah satu kelompok pengayaan di sebelah kiri untuk mengatur anggotanya.</i></p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MasterAsramaPengayaan;